import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

import CustomerDefault from '@components/Profile/components/Layouts/CustomerDefault'

const Display = () => import('./views/Display')
const CustomerDisplay = () => import('./views/CustomerDisplay')

const ROUTE_NAME = 'profile:settings'
const CUSTOMER_ROUTER_NAME = 'profile:customer_settings'

export function createRoutes(options) {
  return [
    route('', Display, ROUTE_NAME, {
      meta: {
        accessConfig: accessPermission([TYPES.CUSTOMER, TYPES.SHIPPER, TYPES.ADMINISTRATOR, TYPES.MANAGER, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH, TYPES.ACCOUNTANT], options),
      },
    }),
    route('customer/', CustomerDisplay, CUSTOMER_ROUTER_NAME, {
      meta: {
        accessConfig: accessPermission([TYPES.CUSTOMER, TYPES.SHIPPER, TYPES.ADMINISTRATOR, TYPES.MANAGER, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH, TYPES.ACCOUNTANT], options),
        layout: CustomerDefault
      },
    }),
  ]
}
